import {APP_ERROR, APP_CLEAR} from '../constants/actionTypes';

export function error(errorNo) {
  // alert ('Błąd nr: ' + errorNo)
  alert ('Błąd komunikacji')
  return {
    type: APP_ERROR,
    errorNo
  }
}

export function clearApp() {
  return {
    type: APP_CLEAR,
  }
}


// WEBPACK FOOTER //
// ./src/actions/appActions.js